/**
 * @author michalstolarski
 * @since 2023-6-29
 */

import * as React from "react";

import { CREDIT_CARDS_PROVIDERS } from "@typings/payments";

import {
  MasterCardV2,
  AmexV2,
  VisaV2,
  PostePay,
} from "@ui/Assets/PaymentProviders";

interface Props {
  providers: CREDIT_CARDS_PROVIDERS[];
}

const creditCardsComponents = {
  [CREDIT_CARDS_PROVIDERS.VISA]: VisaV2,
  [CREDIT_CARDS_PROVIDERS.MASTERCARD]: MasterCardV2,
  [CREDIT_CARDS_PROVIDERS.AMEX]: AmexV2,
  [CREDIT_CARDS_PROVIDERS.POSTEPAY]: PostePay,
};

const CreditCardsLogosV2 = (props: Props): React.ReactElement => {
  return (
    <React.Fragment>
      {props.providers.map(creditCardProvider => {
        const CreditCardProviderLogo =
          creditCardsComponents[creditCardProvider];

        return (
          <li key={creditCardProvider} className="no-styling-li">
            <CreditCardProviderLogo />
          </li>
        );
      })}
    </React.Fragment>
  );
};

export { CreditCardsLogosV2 };
